app.controller('AccountPaymentAcknowledgementController', ['$rootScope', '$scope', '$stateParams', function ($rootScope, $scope, $stateParams) {

    const paymentID = $stateParams.payment_id;
    $scope.payment_response = null;
    $scope.waiting_for_data = true;
    $scope.payment_total = 0;

    $rootScope.service.account.getAccountPaymentStatus(paymentID, function (success, paymentResponse, messages) {
        $scope.waiting_for_data = false;

        if (success) {
            $scope.payment_response = paymentResponse;
            $scope.payment_total = 0;
            for (let i = 0; i < paymentResponse.lines.length; i++) {
                $scope.payment_total += paymentResponse.lines[i].value
            }
        }
    });

}]);